import "../phaser.min.js";
import Common from "../Includes/Common.js";
class Leaderboard extends Phaser.Scene {
    constructor() {
        super('Leaderboard');
        this.common = new Common();
    }

    init(data) {
        this.entries = data.entries;
        this.player = data.player;
    }

    preload() {
        const assetsPath = this.common.assetsPath;
        this.load.atlas('car1-blue-atlas', assetsPath + 'sprites/cars/car1-blue.png', assetsPath + 'sprites/cars/car1-blue.json')
        this.load.atlas('car1-orange-atlas', assetsPath + 'sprites/cars/car1-orange.png', assetsPath + 'sprites/cars/car1-orange.json')
        this.load.atlas('car1-green-atlas', assetsPath + 'sprites/cars/car1-green.png', assetsPath + 'sprites/cars/car1-green.json')
        this.load.atlas('car1-pink-atlas', assetsPath + 'sprites/cars/car1-pink.png', assetsPath + 'sprites/cars/car1-pink.json')
        this.load.atlas('car1-teal-atlas', assetsPath + 'sprites/cars/car1-teal.png', assetsPath + 'sprites/cars/car1-teal.json')
        this.load.atlas('car2-blue-atlas', assetsPath + 'sprites/cars/car2-blue.png', assetsPath + 'sprites/cars/car2-blue.json')
        this.load.atlas('car2-orange-atlas', assetsPath + 'sprites/cars/car2-orange.png', assetsPath + 'sprites/cars/car2-orange.json')
        this.load.atlas('car2-green-atlas', assetsPath + 'sprites/cars/car2-green.png', assetsPath + 'sprites/cars/car2-green.json')
        this.load.atlas('car2-pink-atlas', assetsPath + 'sprites/cars/car2-pink.png', assetsPath + 'sprites/cars/car2-pink.json')
        this.load.atlas('car2-teal-atlas', assetsPath + 'sprites/cars/car2-teal.png', assetsPath + 'sprites/cars/car2-teal.json')
        this.load.atlas('convertible-blue-atlas', assetsPath + 'sprites/cars/convertible-blue.png', assetsPath + 'sprites/cars/convertible-blue.json')
        this.load.atlas('convertible-green-atlas', assetsPath + 'sprites/cars/convertible-green.png', assetsPath + 'sprites/cars/convertible-green.json')
        this.load.atlas('convertible-orange-atlas', assetsPath + 'sprites/cars/convertible-orange.png', assetsPath + 'sprites/cars/convertible-orange.json')
        this.load.atlas('convertible-pink-atlas', assetsPath + 'sprites/cars/convertible-pink.png', assetsPath + 'sprites/cars/convertible-pink.json')
        this.load.atlas('convertible-teal-atlas', assetsPath + 'sprites/cars/convertible-teal.png', assetsPath + 'sprites/cars/convertible-teal.json')
        this.load.atlas('racecar-blue-atlas', assetsPath + 'sprites/cars/racecar-blue.png', assetsPath + 'sprites/cars/racecar-blue.json')
        this.load.atlas('racecar-green-atlas', assetsPath + 'sprites/cars/racecar-green.png', assetsPath + 'sprites/cars/racecar-green.json')
        this.load.atlas('racecar-orange-atlas', assetsPath + 'sprites/cars/racecar-orange.png', assetsPath + 'sprites/cars/racecar-orange.json')
        this.load.atlas('racecar-pink-atlas', assetsPath + 'sprites/cars/racecar-pink.png', assetsPath + 'sprites/cars/racecar-pink.json')
        this.load.atlas('racecar-teal-atlas', assetsPath + 'sprites/cars/racecar-teal.png', assetsPath + 'sprites/cars/racecar-teal.json')
    }

    create() {
        this.rect = this.add.rectangle(0, 0, this.scale.width, this.scale.height, 0x12202e).setOrigin(0, 0);
        this.rect.setInteractive();
        this.rect.on('pointerdown', () => {
            this.scene.stop();
        })

        let baseWidth = 1400;
        this.boardContainer = this.add.container(0, this.scale.height / 2);
        this.physics.world.enable(this.boardContainer);
        this.boardContainer.body.allowGravity = false;
        this.boardContainer.body.setVelocityY(-1 * this.sys.game.loop.delta / 1000); // Vertical speed (e.g., jump)

        const entryY = 40;
        let i = 1;
        this.entries.forEach(entry => {

            let textColor = '#FFFFFF';
            if(entry['player_name'] === this.player.name && entry['school_district'] === this.player.district && entry['car_selection'] === this.player.car.key) {
                textColor = '#cba119';
            }
            let rowContainer = this.add.container((this.scale.width - baseWidth) / 2, 100 + entryY * i);
            let pos = this.add.text(0, 0, '#' + i, {fontFamily: this.common.font, fontSize: 32, fontWeight: 100, color: textColor})
                    .setOrigin(0, 0.5)
            let score = this.add.text(baseWidth / 5 * 0.5, 0, entry['score'], {fontFamily: this.common.font, fontSize: 32, fontWeight: 100, color: textColor})
                    .setOrigin(0, 0.5)
            let name = this.add.text(baseWidth / 5, 0, entry['player_name'], {fontFamily: this.common.font, fontSize: 32, fontWeight: 100, color: textColor})
                    .setOrigin(0, 0.5)

            let district = this.add.text(baseWidth / 5 * 2.3, 0, this.decodeEntities(entry['school_district']), {fontFamily: this.common.font, fontSize: 32, fontWeight: 100, color: textColor})
                    .setOrigin(0, 0.5)
            let car = this.add.sprite(baseWidth / 5 * 4.5, 0, entry['car_selection'] + '-atlas', 0)
                    .setOrigin(0, 0.5)

            let divider = this.add.rectangle(0, 22, baseWidth, 1, 0xFFFFFF).setOrigin(0, 0.5)
            rowContainer.add(pos);
            rowContainer.add(name);
            rowContainer.add(score);
            rowContainer.add(district);
            rowContainer.add(car);
            rowContainer.add(divider);
            this.boardContainer.add(rowContainer);
            i++;
        })

        this.boardContainer.body.setVelocityY(-100);

        this.shelf = this.add.rectangle(0, 0, this.scale.width, this.scale.height / 12 * 3, 0x12202e)
                .setOrigin(0, 0);

        this.logo = this.add.image(this.scale.width / 12, this.scale.height / 12,  'logo')
        this.add.text(this.scale.width / 2, this.scale.height / 12, 'LEADERBOARD',
                {fontFamily: this.common.font, fontSize: 64, fontWeight: 100, color: '#ffffff'})
                .setOrigin(0.5)

        let rankHeading = this.add.text(0, this.scale.height / 12 , 'RANK',
                {fontFamily: this.common.font, fontSize: 32, fontWeight: 100, color: '#ffffff'})
                .setOrigin(0.5)

        let scoreHeading = this.add.text(baseWidth / 5 * 0.5, this.scale.height / 12, 'SCORE',
                {fontFamily: this.common.font, fontSize: 32, fontWeight: 100, color: '#ffffff'})
                .setOrigin(0.5)
        let nameHeading = this.add.text(baseWidth / 5, this.scale.height / 12, 'NAME',
                {fontFamily: this.common.font, fontSize: 32, fontWeight: 100, color: '#ffffff'})
                .setOrigin(0.5)
        let districtHeading = this.add.text(baseWidth / 5 * 2.35, this.scale.height / 12, 'DISTRICT',
                {fontFamily: this.common.font, fontSize: 32, fontWeight: 100, color: '#ffffff'})
                .setOrigin(0.5)
        let rideHeading = this.add.text(baseWidth / 5 * 4.5, this.scale.height / 12, 'RIDE',
                {fontFamily: this.common.font, fontSize: 32, fontWeight: 100, color: '#ffffff'})
                .setOrigin(0.5)

        this.headingsContainer = this.add.container(baseWidth / 5 + 10, this.scale.height / 12 * 1.5, [rankHeading, scoreHeading, nameHeading, districtHeading, rideHeading])
    }

    update() {
        if(this.boardContainer.y < -(this.entries.length * 48)) {
            this.boardContainer.y = this.scale.height;
        }
    }

    decodeEntities(encodedString) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(encodedString, "text/html");
        let string = doc.documentElement.textContent;
        if(string.length > 48) {
            string = string.slice(0, 48) + '...';
        }
        return string;
    }
}

export default Leaderboard;